import React, { useEffect } from 'react';
import Layout from '../../../components/layout';
import SEO from "../../../components/seo";
import ipassImg from '../../../images/ai-tools/ip-asset-assessment-tool.png';
import ToolCard from "../../../components/ToolCard";
import { toolsData } from "../../../data/toolsData";
const IPAssTool = () => {

  const ipAssToolData = toolsData.find(tool => tool.id === "ip-asset-assessment");

  const seo = {
    metaDesc: 'IP Asset Assessment Tool - Inventiv.org',
    metaKeywords: `IP assets, IP Asset Assessment Tool, IP portfolio analysis, patents, trademarks, trade secrets, copyrights, competitive advantage, intellectual property strategy, IP valuation, defensibility analysis, IP portfolio, innovation, licensing, intangible assets, free IP assessment tool, Get started now (CTA), IP health check report, comprehensive IP asset assessment`,
  }

  useEffect(() => {
    document?.body.classList.add('no-home');
  }, []);

  return (
    <Layout>
      <SEO title="IP Asset Assessment Tool - Inventiv.org" canonical='/ai-tools/ip-asset-assessment' seo={seo} />
      <div class="banner banner-2 pt-3 pb-3" style={{ background: 'url(/assets/img/banner/fielado2-1024x480-1.png)', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>
        <div class="container">
          <div class="row ">
            <div class="col-12 col-md-8  mt-3 mb-3">
              <h1 class="w-clr">
                IP Asset Assessment Tool
              </h1>
            </div>
          </div>
        </div>
      </div>

      <section className="mb-3 pb-3 wow fadeInUp delay-04s">
        <div className="container ">

          <section className="mt-3 wow fadeInUp delay-04s">
            <h2>Problem & Solution</h2>
            <p className="f-16">
              Uncertain about the true value and risk of your Intellectual Property? Many businesses
              underestimate their competitive edge because they lack a clear, comprehensive view of their IP
              assets—from patents and trademarks to trade secrets and copyrights. Our proprietary IP Asset
              Assessment Tool is designed to solve this. In minutes, our platform delivers an objective,
              data-driven IP portfolio analysis that pinpoints high-value assets, flags potential infringement
              risks, and identifies white spaces for strategic growth. Stop guessing and start strategizing with
              a clear picture of your company's most valuable intangible resources.
            </p>

            <h2>Benefit-Driven Value Proposition</h2>
            <p className="f-16">
              Maximize the value of your innovation and secure a competitive advantage. A successful
              intellectual property strategy hinges on timely, accurate valuation and defensibility. Our
              assessment tool goes beyond a simple list; it provides an IP valuation score, a defensibility
              analysis, and crucial market alignment data. Whether you're preparing for investment, licensing
              negotiations, or competitive litigation, this actionable report empowers you to make informed,
              high-stakes business decisions. Future-proof your business by transforming your raw innovation
              into a robust, strategic IP portfolio.
            </p>

            <h2>Call to Action & Trust</h2>
            <p className="f-16">
              Ready to unlock the full potential of your intangible assets? Don't let your most valuable
              creations remain unprotected or undervalued. Trusted by forward-thinking companies
              worldwide, our free IP assessment tool provides the foundational data you need to move
              forward with confidence. Get started now by securely submitting your basic asset information
              and receive your preliminary IP health check report instantly. Click to begin your comprehensive
              IP asset assessment and take the first step toward a more strategic, profitable IP future.
            </p>
          </section>

          <ToolCard
            index={0}
            key={ipAssToolData.id}
            title={ipAssToolData.title}
            description={ipAssToolData.description}
            features={ipAssToolData.features}
            icon={ipAssToolData.icon}
            image={ipAssToolData.image}
            imageAlt={ipAssToolData.imageAlt}
            buttonUrl='/ai-tools/ip-asset-assessment/tool'
            reverseLayout={true}
          />

        </div>
      </section>
    </Layout>
  )
};

export default IPAssTool;